import { render, staticRenderFns } from "./carousel2.vue?vue&type=template&id=371ba2d8&scoped=true&"
import script from "./carousel2.vue?vue&type=script&lang=js&"
export * from "./carousel2.vue?vue&type=script&lang=js&"
import style0 from "./carousel2.vue?vue&type=style&index=0&id=371ba2d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ba2d8",
  null
  
)

export default component.exports